module.exports = __webpack_public_path__ + "img/MUS.e9183bad.svg";